import { render, staticRenderFns } from "./EmployerOtherAgeRequirementYearsInput.vue?vue&type=template&id=041afdd7&"
import script from "./EmployerOtherAgeRequirementYearsInput.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherAgeRequirementYearsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports